import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import { PATHS } from '../../../constants';

export const getSellerPagePath = (username) =>
    pathfinder(PATHS.SELLER_PAGE, {
        username,
    });

export const getGigPath = ({ username, slug }) =>
    pathfinder(PATHS.GIG_PAGE, {
        username,
        slug,
    });

export const getSubCategoryPath = ({ categoryId, subCategoryId }, locale) => {
    if (!(categoryId && subCategoryId)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(subCategoryId, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = translate(`categories.category_${categoryId}.cached_slug`, { locale });
    const subCategorySlug = translate(`sub_categories.sub_category_${subCategoryId}.cached_slug`, { locale });
    const params = {
        category_id: categorySlug,
        id: subCategorySlug,
    };

    const options = { query: { source: 'shared-assets' } };

    return categorySlug && subCategorySlug ? pathfinder(PATHS.SUB_CATEGORY_PAGE, params, options) : '';
};
